import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import shareholderRegistered from "../../assets/shareholder-registered.svg";

const ShareholderRegistered = ({
  setActiveIndex,
  resetRegData,
  setIsCongrats,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const closeWizard = () => {
    navigate(`/entity/${id}/share-holders`);
  };

  const handleNewShareholder = () => {
    setActiveIndex(0);
    setIsCongrats(false);
    resetRegData();
  };

  return (
    <div>
      <div className="formgrid grid flex justify-content-center align-item-center">
        <div className="no-key-container">
          <img
            src={shareholderRegistered}
            alt="file-upload"
            className="file-upload-logo"
          />
          <div className="no-key-align">
            <p className="shareholder-registered my-2">
              Shareholder registered
            </p>
            <p className="drag-drop-text mt-0 mb-4">
              Your shareholder has been created.
            </p>
          </div>
          <div className="inline-flex gap-3">
            <button
              className="add-new-shareholder"
              onClick={handleNewShareholder}
            >
              Add New Shareholder <span className="pi pi-plus ml-2"></span>
            </button>
            <button
              type="button"
              className="cancel-btns close-wizard"
              onClick={closeWizard}
            >
              Close Wizard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareholderRegistered;
